import type { FC } from 'react';
import React from 'react';
import { Body, Flex, Glyph, Pill } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import type { LocationPillProps } from '@/components/FlightSummary/HotelVoucher/LocationPill/config/types';

const parseLocationPillText = (
  amountNights: number,
  destinationName: string,
  t: any
): string => {
  if (amountNights === 1) {
    return t('locationPill.nights.singular', { amountNights, destinationName });
  }
  return t('locationPill.nights.plural', { amountNights, destinationName });
};

const LocationPill: FC<LocationPillProps> = ({
  amountNights,
  destinationName,
}) => {
  const { t } = useTranslation();

  if (destinationName.length === 0 || amountNights <= 0) {
    return null;
  }

  const locationPillText = parseLocationPillText(
    amountNights,
    destinationName,
    t
  );

  return (
    <Pill
      type="promotional"
      sx={{
        pl: 'base',
        borderRadius: 'full',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      }}
    >
      <Flex sx={{ lineHeight: '12px' }} my="tiny">
        <Flex alignSelf="flex-start" flexShrink={0} pt="tiny">
          <Glyph
            category="Content"
            name="Location"
            size="tiny"
            color="primary.80"
          />
        </Flex>
        <Flex ml="2x_small" data-testid="location-pill">
          <Body type="xSmall">{locationPillText}</Body>
        </Flex>
      </Flex>
    </Pill>
  );
};

export default LocationPill;
